import dayjs from 'dayjs';
import { createContext, useContext, useState } from 'react';

const CalendarActionsContext = createContext(null);

export const CalendarActionsProvider = ({ children }) => {
  const [selectedDay, setSelectedDay] = useState(dayjs());

  const handleSelectDay = (day) => {
    setSelectedDay(day);
  };

  return (
    <CalendarActionsContext.Provider value={{ handleSelectDay, selectedDay }}>
      {children}
    </CalendarActionsContext.Provider>
  );
};

export const useCalendarActions = () => useContext(CalendarActionsContext);
